import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchProjectDetail = createAsyncThunk("fetchMeetingDetail", async ({ id }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.get(`/leads/details?id=${id}`, config);

	return response.data.data;
});

const ProjectDetailSlice = createSlice({
	name: "ProjectDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	extraReducers: (builder) => {
		builder.addCase(fetchProjectDetail.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchProjectDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchProjectDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ProjectDetailSlice.reducer;
